import React from 'react'
import { useParams } from 'react-router-dom'
import { ShiftDetailMain } from './ShiftDetailMain'
import { ShiftDetailProvider } from './context/ShiftDetailProvider'
import { ShiftDetailWorkflowsProvider } from './context/ShiftDetailWorkflowsProvider'
import { AssignShiftFlow } from './workflows/AssignShiftFlow/AssignShiftFlow'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'
import { SwitchTiersFlow } from './workflows/SwitchTiersFlow/SwitchTiersFlow'
import { CreateCustomShiftNotificationFlow } from './workflows/CreateCustomShiftNotificationFlow'
import { DayforceJobProvider } from './context/DayforceJobProvider'

export const ShiftDetail = () => {
  const { shiftId } = useParams()
  return (
    <NuqsAdapter>
      <ShiftDetailProvider shiftId={Number(shiftId)}>
        <ShiftDetailWorkflowsProvider>
          <DayforceJobProvider>
            <ShiftDetailMain />
            <AssignShiftFlow />
            <SwitchTiersFlow />
            <CreateCustomShiftNotificationFlow />
          </DayforceJobProvider>
        </ShiftDetailWorkflowsProvider>
      </ShiftDetailProvider>
    </NuqsAdapter>
  )
}
